import type { ThreadTone } from "@/lib/conversation/thread-header"

/**
 * One palette for the strip above a conversation, in its own module so the header and the
 * badges beside it can share it without importing each other.
 */

export const STATE_TONE_STYLES: Record<ThreadTone, string> = {
  neutral: "border-gray-300 bg-gray-50 text-gray-600",
  info: "border-blue-300 bg-blue-50 text-blue-600",
  success: "border-green-300 bg-green-50 text-green-600",
  warning: "border-amber-300 bg-amber-50 text-amber-600",
}

export const BANNER_TONE_STYLES: Record<ThreadTone, string> = {
  neutral: "bg-muted/40 text-muted-foreground",
  info: "bg-blue-50 text-blue-700 dark:bg-blue-950/30 dark:text-blue-400",
  success: "bg-green-50 text-green-700 dark:bg-green-950/30 dark:text-green-400",
  warning: "bg-amber-50 text-amber-700 dark:bg-amber-950/30 dark:text-amber-400",
}
